import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/31ddae26-918c-4c5a-957f-539a4cbf5f74/workspace/streffy-middle-office_CyFO/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.for-each";
import "/root/workspace/__flow_work/__flow_builds/31ddae26-918c-4c5a-957f-539a4cbf5f74/workspace/streffy-middle-office_CyFO/node_modules/core-js/modules/es6.array.iterator.js";
import "/root/workspace/__flow_work/__flow_builds/31ddae26-918c-4c5a-957f-539a4cbf5f74/workspace/streffy-middle-office_CyFO/node_modules/core-js/modules/es6.promise.js";
import "/root/workspace/__flow_work/__flow_builds/31ddae26-918c-4c5a-957f-539a4cbf5f74/workspace/streffy-middle-office_CyFO/node_modules/core-js/modules/es6.object.assign.js";
import "/root/workspace/__flow_work/__flow_builds/31ddae26-918c-4c5a-957f-539a4cbf5f74/workspace/streffy-middle-office_CyFO/node_modules/core-js/modules/es7.promise.finally.js";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
// Vue
import Vue from 'vue';
import App from "./App";

// 配置
import Setting from "./setting";
// 自动清除本地存储
import { CacheCleaner } from "./cacheCleaner";

// 混合
import mixinApp from '@/mixins/app';
import mixinCommons from '@/mixins/commons';

// 插件
import plugins from '@/plugins';
import dayjs from "dayjs";

// store
import store from '@/store/index';

// iView 和 iView Pro
import ViewUI from 'view-design';
import iViewPro from '@/libs/iview-pro/iview-pro.min.js';

// 菜单和路由
import router from "./router";
// import menuHeader from '@/menu/header';
// import menuSider from '@/menu/sider';
// import { frameInRoutes } from '@/router/routes';

// 多语言
import _i18n from '@/i18n';

// 方法
import { getHeaderName, getMenuSider, getSiderSubmenu } from '@/libs/system';
import utilThree from '@/libs/util.three.js';

// 高德地图

// 内置组件
import iLink from '@/components/link';
import iFrame from '@/components/frame';
import ICopyBtn from '@/components/cus-copy-btn';
import ICustomIconBtn from '@/components/custom-icon-btn';
import NotFoundTips from '@/components/not-found-tips/index.vue';
import CardTitle from '@/components/card-title/index.vue';
import FileUpload from '@/components/file/upload.vue';
import FileExport from '@/components/file/export.vue';

// 过滤器
import * as filters from '@/filters/index.js';
import * as directive from '@/directive/index.js';

// 使用样式，修改主题可以在 styles 目录下创建新的主题包并修改 iView 默认的 less 变量
// 参考 https://www.iviewui.com/docs/guide/theme
import '@/plugins/flexible';
import "./styles/index.less";
import "./libs/iview-pro/iview-pro.css";
if (window) window.$t = function (key, value) {
  return _i18n.t(key, value);
};

// 应用启动时自动清理旧版本缓存
CacheCleaner.autoCleanOnUpdate();
Vue.use(plugins);
Vue.use(ViewUI, {
  i18n: function i18n(key, value) {
    return _i18n.t(key, value);
  }
});
Vue.use(iViewPro);
Vue.component('i-link', iLink);
Vue.component('i-frame', iFrame);
Vue.component('i-copy-btn', ICopyBtn);
Vue.component('i-cus-icon-btn', ICustomIconBtn);
Vue.component('not-found-tips', NotFoundTips);
Vue.component('card-title', CardTitle);
Vue.component('file-upload', FileUpload);
Vue.component('file-export', FileExport);

// 事件总线
Vue.prototype.$EventBus = new Vue();
// 全局使用dayjs
Vue.prototype.$Dayjs = dayjs;
Vue.prototype.$Filters = filters;
// Setting
Vue.prototype.$Setting = Setting;
Vue.prototype.$ViewUI = ViewUI;

// 全局引入mixin-Commons
Vue.mixin(mixinCommons);

// 过滤器
Object.keys(filters).forEach(function (key) {
  Vue.filter(key, filters[key]);
});

// 全局指令
Object.keys(directive).forEach(function (key) {
  Vue.directive(key, directive[key]);
});

// 处理element-ui内联样式px2rem,全局挂载
function px2rem(px) {
  if (/%/gi.test(px)) {
    // 有百分号%，特殊处理，表述pc是一个有百分号的数，比如：90%
    return px;
  } else {
    return parseFloat(px) / 192 + 'rem';
  }
}
Vue.prototype.$px2rem = px2rem; // 放到全局

// Vue.directive('inputNumber', {
//     inserted (el, binding) {
//         if (el.children[2]._value === 0) {
//             el.children[2].value = ''
//             el.children[2]._value = ''
//         }
//         el.oninput = () => {
//             el.children[2].value = el.children[2].value
//                 .replace(/[^\d^.]+/g, '') // 非数字替换成空字符串
//                 .replace(/^\./g, '') // 限制不能.开头
//                 .replace('.', '$#$') // 限制只能输入一个小数点
//                 .replace(/\./g, '')
//                 .replace('$#$', '.')
//             if (el.children[2]._value === '') {
//                 el.children[2].value = 0
//             }
//             // const customEvent = new CustomEvent('input', { value: 0 })
//             // el.children[2].dispatchEvent(customEvent)
//             el.children[2].dispatchEvent(new Event('input'))
//             // if (el.children[2]._value === 0) {
//             //     el.children[2].value = ''
//             // }
//         }
//         el.children[2].addEventListener('blur', () => {
//             if (el.children[2]._value === 0) {
//                 el.children[2].value = ''
//             }
//         });
//         MutationObserver
//     },
//     componentUpdated (el) {
//         if (el.children[2]._value === 0) {
//             el.children[2].value = ''
//         }
//     }
// })

var parseUrlParams = function parseUrlParams(url) {
  var params = {};
  if (!url || url === '' || typeof url !== 'string') {
    return params;
  }
  var paramsRegex = /[?&]+([^=&]+)=([^&]*)/gi;
  var match;
  // eslint-disable-next-line no-labels
  while (match = paramsRegex.exec(url)) {
    // eslint-disable-line
    params[match[1]] = match[2];
  }
  return params;
};
new Vue({
  mixins: [mixinApp],
  router: router,
  store: store,
  i18n: _i18n,
  render: function render(h) {
    return h(App);
  },
  created: function created() {
    // 处理路由 得到每一级的路由设置
    // this.$store.commit('admin/page/init', frameInRoutes);
    // // 设置顶栏菜单
    // this.$store.commit('admin/menu/setHeader', menuHeader);
    // 加载用户登录的数据
    this.$store.dispatch('admin/account/load');
    // 初始化品牌信息
    this.$store.dispatch('admin/brandInfo/load');
    // 初始化全屏监听
    this.$store.dispatch('admin/layout/listenFullscreen');
    // 监听视口大小变化
    this.$store.dispatch('admin/layout/listenResize');

    // 初始化-登录/菜单
    var pathName = window.location.pathname;
    console.log('【启动 created】路由', pathName);
    var urlParams = parseUrlParams(window.location.href);
    console.log('【启动 created】路由参数', urlParams);
    if (urlParams && urlParams.three === "true" && urlParams.t) {
      utilThree.getTicketUser(urlParams, pathName, router);
    } else {
      // 加载用户登录的数据
      this.$store.dispatch('admin/account/load');
      // 初始化品牌信息
      this.$store.dispatch('admin/brandInfo/load');
    }
  },
  watch: {
    // 监听路由 控制侧边栏显示 标记当前顶栏菜单（如需要）
    '$route': function () {
      var _$route = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(to, from) {
        var menuSider, path, headerName, filterMenuSider, openNames;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (to) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              menuSider = this.$store.state.admin.menu.menuSider;
              if (!Setting.dynamicSiderMenu) {
                path = to.matched[to.matched.length - 1].path;
                headerName = getHeaderName(path, menuSider);
                if (headerName === null) {
                  path = to.path;
                  headerName = getHeaderName(path, menuSider);
                }
                // 在 404 时，是没有 headerName 的
                if (headerName !== null) {
                  this.$store.commit('admin/menu/setHeaderName', headerName);
                  // this.$store.commit('admin/menu/setMenuSider', menuSider);
                  filterMenuSider = getMenuSider(menuSider, headerName);
                  this.$store.commit('admin/menu/setSider', filterMenuSider);
                  if (to.meta && to.meta.activePath) {
                    this.$store.commit('admin/menu/setActivePath', to.meta.activePath);
                  } else {
                    this.$store.commit('admin/menu/setActivePath', to.path);
                  }
                  openNames = getSiderSubmenu(path, menuSider);
                  this.$store.commit('admin/menu/setOpenNames', openNames);
                }
              }
              this.appRouteChange(to, from);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function $route(_x, _x2) {
        return _$route.apply(this, arguments);
      }
      return $route;
    }()
  }
}).$mount('#app');